<template>
  <v-data-table
    :headers="tabela.headers"
    :items="[relatorioUnidade]"
    item-key="id"
    disable-pagination
    hide-default-footer
    show-expand
    single-expand
  >
    <!-- Cargos/Funções (Botão de Expansão) -->
    <template
      v-slot:[`item.data-table-expand`]="{
        item,
        expand,
        isExpanded,
      }"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            height="100%"
            text
            width="100%"
            @click="expand(!isExpanded)"
            v-on="on"
          >
            <v-badge right>
              <template v-slot:badge>
                <span>
                  {{ item.cargos.length }}/{{ item.funcoes.length }}
                </span>
              </template>
              <v-icon
                color="grey lighten-0"
                large
              >
                badge
              </v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Clique para exibir os cargos e funções</span>
      </v-tooltip>
    </template>

    <!-- Cargos e Funções (Lista Expandida) -->
    <template v-slot:expanded-item="{ headers, item }">
      <td
        :colspan="headers.length"
        class="justify-center"
      >
        <v-row>
          <v-spacer />
          <v-col>
            <v-row class="justify-center">
              <app-title texto="CARGOS E FUNÇÕES" />
            </v-row>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row>
          <v-spacer />
          <v-col cols="10">
            <v-simple-table class="elevation-0 mb-4">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>
                      Cargo
                    </th>
                    <th class="text-center" style="width: 10%; min-width: 10%;">
                      Quantidade
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="cargo in item.cargos"
                    :key="cargo.id"
                  >
                    <td>
                      <div class="d-flex flex-row ma-1">
                        <span>{{ cargo.nome }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="text-center">
                        <span>{{ cargo.quantidade }}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row>
          <v-spacer />
          <v-col cols="10">
            <v-simple-table class="elevation-0 mb-4">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>
                      Função
                    </th>
                    <th class="text-center" style="width: 10%; min-width: 10%;">
                      Quantidade
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="funcao in item.funcoes"
                    :key="funcao.id"
                  >
                    <td>
                      <div class="d-flex flex-row ma-1">
                        <span>{{ funcao.nome }}</span>
                      </div>
                    </td>
                    <td>
                      <div class="text-center">
                        <span>{{ funcao.quantidade }}</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-spacer />
        </v-row>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import AppTitle from '@/components/core/AppTitle';

export default {
  name: 'TabelaQuadroResumoUnidadeProfissional',

  components: {
    AppTitle,
  },

  props: {
    relatorio: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  data() {
    return {
      tabela: {
        headers: [
          {
            text: 'UNIDADE',
            value: 'nome',
            sortable: false,
          },
          {
            text: 'SIGLA',
            value: 'sigla',
            sortable: false,
          },
          {
            text: 'CARGOS/FUNÇÕES',
            value: 'data-table-expand',
            width: '10%',
            align: 'center',
          },
          {
            text: 'TOTAL DE SERVIDORES',
            value: 'servidores',
            width: '10%',
            sortable: false,
            align: 'center',
          },
        ],
      },
    };
  },

  computed: {
    relatorioUnidade() {
      return {
        nome: this.relatorio.nome,
        sigla: this.relatorio.sigla,
        cargos: this.relatorio.cargos,
        funcoes: this.relatorio.funcoes,
        servidores: this.relatorio.quantidadePerfis,
      };
    },
  },
};
</script>
